/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {gsap, TimelineLite, TweenLite, Elastic} from "gsap";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {Oktoberfest} from "../../Oktoberfest";
import {OktoberfestGameConfig} from "../../OktoberfestGameConfig";
import {IBetLineWinData} from "../../server/data/IOktoberfestData";
import {OktoberfestSymbol} from "../../symbol/OktoberfestSymbol";
import {OktoberfestSound} from "../../sound/OktoberfestSound";


export class IndividualWinController {

    private _currentTimeline: TimelineLite | null;
    private _stopped: boolean;
    private _individualWinPresentationLineDuration: number = 0.9;

    constructor() {
    }

    public start(): void {
        this._stopped = false;
        if (Oktoberfest.model.parsedGameData.betWins.length > 0 && Oktoberfest.model.parsedGameData.singleWin > 0) {
            // Add a small delay for the first time so we don't start to play before the autoPlay start next spin.
            new TimelineLite().add(() => this.playNextBetWin(0), 1);
            if( Oktoberfest.model.parsedGameData.mode==="WILD_RESPIN"&& Oktoberfest.model.parsedGameData.nextMode==="NORMAL"){
                OktoberfestSound.switchMusic({name: OktoberfestSound.getMusicNameByMode("NORMAL")});
            }
        }
    }

    public async stop(): Promise<any> {
        this._stopped = true;
        if (this._currentTimeline && this._currentTimeline.isActive()) {
            await this._currentTimeline.progress(1);
        }
        Oktoberfest.betlines.onHideAllBetLines();
        this._currentTimeline = null;
        await Promise.resolve();
    }

    private playNextBetWin(index: number, delay: number = 0): void {
        const data = Oktoberfest.model.parsedGameData;
        const winRatio = data.currentWinRatioConfig?.ratio!;
        if (index === data.betWins.length) {
            index = 0;
        }
        const tl = gsap.timeline();
        if (OktoberfestGameConfig.BET_WIN_MODE === BetWinMode.BET_LINE && !this._stopped ) {
            if (data.betWins.length > 1) {
                Oktoberfest.betlines.onHideAllBetLines();
            }
            tl.add(this.getBetLineAnimation(<IBetLineWinData>data.betWins[index], winRatio), delay);
        }
        tl.add(() => {
            if (!this._stopped) {
                this.playNextBetWin(index + 1);
            }
        });
        this._currentTimeline = tl;
    }

    private getBetLineAnimation(winData: IBetLineWinData, winRatio: number): TimelineLite {
        const tl = gsap.timeline();
        for (let reelId = 0; reelId < winData.nrOfSymbols; reelId++) {
            tl.add(this.getSymbolWinAnimation(reelId, winData.betLine[reelId], winRatio), 0);
            tl.add(() => {
                Oktoberfest.betlines.onShowWinBetLine(winData.betLineIndex + 1)
            }, 0);
        }
        return tl;
    }

    private getSymbolWinAnimation(reelId: number, symId: number, winRatio: number): TimelineLite {
        const tl = gsap.timeline();
        const sym = Oktoberfest.reels[reelId].getSymbol(symId, false, true);
        tl.add(() => Oktoberfest.reels[reelId].reelView.addWinSymbol(sym));// no need to have win state in this game?
        tl.add(this.playAnimation(sym));
        return tl;
    }

    private playAnimation(symbol: OktoberfestSymbol): TimelineLite {
        //details copied from oktoberfest original
        let timeline: TimelineLite = new TimelineLite();
        timeline.add(new TweenLite(symbol.scale, 0.7, {
            x: 1.05,
            y: 1.05,
            ease: Elastic.easeOut.config(1.2, 0.6)
        }));
        timeline.add(new TweenLite(symbol.scale, 0.2, {x: 0.95, y: 0.95}));
        return timeline;
    }

}
